module.exports = __webpack_public_path__ + "img/麦港飞舟.cb5948f3.jpg";